module.exports = __webpack_public_path__ + "img/feature-2.7d9c4bdb.png";